import { defineComponent, computed } from "vue";
import { u as useSizeProps, a as useSize } from "../../composables/useSize-a4b897f3.mjs";
import { u as useColors } from "../../composables/useColors-6d98be99.mjs";
const _sfc_main = defineComponent({
  name: "VaScrollContainer",
  props: {
    ...useSizeProps,
    vertical: { type: Boolean, default: false },
    horizontal: { type: Boolean, default: false },
    color: { type: String, default: "secondary" },
    rtl: { type: Boolean, default: false },
    gradient: { type: Boolean, default: false },
    sizesConfig: {
      type: Object,
      default: () => ({
        defaultSize: 4,
        sizes: { small: 4, medium: 6, large: 8 }
      })
    },
    size: {
      type: String,
      default: "small",
      validator: (v) => ["small", "medium", "large"].includes(v)
    }
  },
  setup(props) {
    const { getColor } = useColors();
    const { sizeComputed } = useSize(props);
    return {
      overflowX: computed(() => props.horizontal ? "auto" : "hidden"),
      overflowY: computed(() => props.vertical ? "auto" : "hidden"),
      scrollColor: computed(() => {
        const color = getColor(props.color);
        return props.gradient ? `linear-gradient(0deg, var(--va-scroll-container-scrollbar-gradient-to) 0%, ${color} 100%)` : color;
      }),
      scrollbarSize: computed(() => sizeComputed.value),
      scrollbarPosition: computed(() => props.rtl ? "rtl" : "ltr")
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaScrollContainer.css';
//# sourceMappingURL=VaScrollContainer.vue_vue_type_script_lang-b1e0b683.mjs.map
